import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

export const NationalSavingsCertificate = () => {
  return (
    <>
      <TopBanner content={"National Savings Certificate"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Save Confidently, Earn Securely</h2>
          <p>
            The National Savings Certificate (NSC) is a fixed-income savings
            scheme offered by the Indian government perfect for low-risk
            investors who want guaranteed returns with tax-saving benefits. It’s
            a great choice for long-term savers who prefer stability over
            speculation.
          </p>

          <p>
            You can buy NSC at any post office, making it easily accessible and
            reliable for every Indian household.
          </p>

          <h3>Why Choose NSC?</h3>

          <ul>
            <li>
              Guaranteed interest (revised by the government every quarter)
            </li>
            <li>Lock-in period of 5 years</li>
            <li>Eligible for tax deduction under Section 80C</li>
            <li>Safe investment backed by the Government of India</li>
            <li>Start with as little as ₹1,000  no upper limit </li>
          </ul>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default NationalSavingsCertificate;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
